import React from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import Modal from 'utils/packages/Modal';
import { rem } from 'design-system/values';
import { GroupExpenseCRow } from 'features/group/components/GroupExpenseCRow';
import { groupModalContainerStyle } from './groupModalContainerStyle';
export const PaidByModal = {
    show: ({ onSelected, options = {}, selectedUser, users, }) => {
        Modal.show(<View style={styles.modalContent}>
        <FlatList data={users || []} renderItem={({ item }) => (<GroupExpenseCRow selected={selectedUser?.id === item.id} groupUser={item} onPress={() => {
                    onSelected(item);
                    Modal.hide();
                }}/>)}/>
      </View>, {
            containerStyle: groupModalContainerStyle,
            title: 'Paid by',
            ...options,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modalContent: {
        paddingVertical: rem(20),
    },
});
